import { Paper } from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
import { Modal, Spinner, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { baseUrl } from "../../../../services/config";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { PremissionChecker } from "../../../../services/PremissionChecker";

const SingleResult = () => {
  const pageStyle = `
    @page {
      size: a4 !important;
    }
    `;

  const componentRef = useRef(null);
  const tableRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  const alert = useAlert();

  const authtoken = localStorage.getItem("userToken");
  const [allsessions, setallsessions] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [selectedcampus, setselectedcampus] = useState("");
  const [currentsession, setcurrentsession] = useState("");
  const [selectedsection, setselectedsection] = useState("");
  const [allsubjects, setallsubjects] = useState([]);
  const [selectiveSubjects, setSelectiveSubjects] = useState([]);
  const [selectedsubject, setselectedsubject] = useState("");
  const [educationType, setEducationType] = useState(1);

  const [exampsTypeList, setexampsTypeList] = useState([]);
  const [selectedExamType, setselectedExamType] = useState("");
  const [printmodal, setprintmodal] = useState(false);
  const [allexamslist, setallexamslist] = useState([]);

  const [stu_classesList, setstu_classesList] = useState([]);

  const [admissionNo, setAdmissionNo] = useState("");

  const [allclasses, setallclasses] = useState([]);
  const [allCampusSections, setallCampusSections] = useState([]);

  const [updateloading, setupdateloading] = useState(false);
  const [allResultList, setallResultList] = useState([]);
  const [gradeSystems, setGradeSystems] = useState([]);

  const [loading, setloading] = useState(false);
  const [isPracticalMode, setisPracticalMode] = useState(false);

  const [examDetails, setexamDetails] = useState({});
  const [classDetails, setclassDetails] = useState({});
  const [sectionDetails, setsectionDetails] = useState({});
  const [subjectDetails, setsubjectDetails] = useState({});
  const [printEmpty, setPrintEmpty] = useState(true);

  //printing states

  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  useEffect(() => {
    // getAllCampus();
    getAllSubjects();
    getAllExampTypes();
    getAllSessions();
    getSettingData();
    getGradeSystems();
    // getAllClasses()
  }, []);

  const getGradeSystems = () => {
    fetch(`${baseUrl}/grade-systems`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setGradeSystems(data.payload || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data.payload);
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setallsessions([...data.payload]);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setcurrentsession(session.id);
            // getAllExamsList(session.id)
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllExamsList = (id) => {
    const data = {
      year_id: currentsession,
      campus_id: id,
    };

    fetch(`${baseUrl}/exam_for_session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("get exam", data);

        setallexamslist([...data.payload]);

        // setallclasses(data.payload[0]?.student_classes)

        // getassignedExamsList(data.payload)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllExampTypes = async () => {
    await fetch(`${baseUrl}/exam-types`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setexampsTypeList(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getAllSubjects = async () => {
    await fetch(`${baseUrl}/subject`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsubjects(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const onCampusChange = async (id) => {
    setselectedcampus(id);
    getAllExamsList(id);
  };

  const onChangeSession = (id) => {
    setcurrentsession(id);
  };

  const getStudentResult = () => {
    // console.log(selectedExamType + " " + selectedcampus + " " + selectedclass);
    if (selectedExamType === "" || selectedcampus === "") {
      return alert.error("Please select all fileds");
    }
    if (admissionNo === "") {
      return alert.error("Please enter admission no");
    }

    setloading(true);
    let data = {
      year_id: currentsession,
      exam_id: selectedExamType,
      admission_id: admissionNo,
    };
    fetch(`${baseUrl}/single-student-result-get`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.metadata.success) {
          console.log(data.payload.results);

          const res = data.payload.results.sort(
            (a, b) => a.student.admission_id - b.student.admission_id,
          );
          setallResultList(res);
          setexamDetails(data.payload.exam);
          setclassDetails(data.payload.class);
          setsectionDetails(data.payload.section);
          setsubjectDetails(data.payload.subject);
          setloading(false);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            toast.error(msg);
            setloading(false);
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
      });
  };

  const getGradeForPercentage = (percentage) => {
    const selectedExam = allexamslist.find(
      (exam) => String(exam.id) === String(selectedExamType),
    );
    const selectedGradeSystem =
      selectedExam?.grade_system ??
      selectedExam?.grade_system_id ??
      examDetails?.grade_system ??
      examDetails?.grade_system_id;

    if (selectedGradeSystem === undefined || selectedGradeSystem === null) {
      return "";
    }

    const gradeSystemId =
      selectedGradeSystem?.id ||
      selectedGradeSystem?.grade_system_id ||
      selectedGradeSystem;
    const gradeSystemById = gradeSystems.find(
      (item) => String(item.id) === String(gradeSystemId),
    );
    const gradeSystemName = String(
      selectedGradeSystem?.name ||
        selectedGradeSystem?.grade_system ||
        gradeSystemById?.name ||
        selectedGradeSystem,
    )
      .trim()
      .toLowerCase();

    const gradesForSystem = gradeSystems.filter(
      (item) =>
        String(item.name || "")
          .trim()
          .toLowerCase() === gradeSystemName,
    );
    const grade =
      gradesForSystem.find(
        (item) =>
          percentage >= Number(item.min_marks) &&
          percentage <= Number(item.max_marks),
      ) ||
      [...gradesForSystem]
        .sort((a, b) => Number(b.min_marks) - Number(a.min_marks))
        .find((item) => percentage >= Number(item.min_marks));

    return grade?.grade || "";
  };

  const calculateResult = (gainMarks, practicalMarks, fullMarks) => {
    const totalMarks = Number(fullMarks);
    const obtainedMarks =
      Number(gainMarks || 0) +
      (isPracticalMode ? Number(practicalMarks || 0) : 0);

    if (!totalMarks) {
      return { percentage: "0.00", grade: "" };
    }

    const percentage = (obtainedMarks / totalMarks) * 100;

    return {
      percentage: percentage.toFixed(2),
      grade: getGradeForPercentage(percentage),
    };
  };

  const OnchangefullMark = (e, index) => {
    const fullMarks = e.target.value;

    setallResultList((results) =>
      results.map((item, itemIndex) => {
        if (itemIndex !== index) {
          return item;
        }

        const marksExceedTotal =
          Number(item.gain_marks || 0) + Number(item.practical_marks || 0) >
          Number(fullMarks || 0);
        const gainMarks = marksExceedTotal ? 0 : item.gain_marks;
        const practicalMarks = marksExceedTotal ? 0 : item.practical_marks;

        return {
          ...item,
          full_marks: fullMarks,
          gain_marks: gainMarks,
          practical_marks: practicalMarks,
          ...calculateResult(gainMarks, practicalMarks, fullMarks),
        };
      }),
    );
  };

  const onChangeGainMarks = (e, index) => {
    const gainMarks = e.target.value;
    const item = allResultList[index];
    const obtainedMarks =
      Number(gainMarks || 0) +
      (isPracticalMode ? Number(item.practical_marks || 0) : 0);

    if (obtainedMarks <= Number(item.full_marks)) {
      setallResultList((results) =>
        results.map((result, resultIndex) =>
          resultIndex === index
            ? {
                ...result,
                gain_marks: gainMarks,
                ...calculateResult(
                  gainMarks,
                  result.practical_marks,
                  result.full_marks,
                ),
              }
            : result,
        ),
      );
    }
  };

  const calculatePartialResult = (
    gainMarksRW,
    gainMarksLS,
    fullMarksRW,
    fullMarksLS,
  ) => {
    const totalMarks = Number(fullMarksRW || 0) + Number(fullMarksLS || 0);
    const obtainedMarks = Number(gainMarksRW || 0) + Number(gainMarksLS || 0);

    if (!totalMarks) {
      return { percentage: "0.00", grade: "" };
    }

    const percentage = (obtainedMarks / totalMarks) * 100;

    return {
      percentage: percentage.toFixed(2),
      grade: getGradeForPercentage(percentage),
    };
  };

  const OnchangefullMarkRW = (e, index) => {
    const fullMarksRW = e.target.value;

    setallResultList((results) =>
      results.map((result, resultIndex) => {
        if (resultIndex !== index) {
          return result;
        }

        const gainMarksRW =
          Number(result.gain_marks_rw || 0) > Number(fullMarksRW || 0)
            ? 0
            : result.gain_marks_rw;

        return {
          ...result,
          full_marks_rw: fullMarksRW,
          gain_marks_rw: gainMarksRW,
          ...calculatePartialResult(
            gainMarksRW,
            result.gain_marks_sl,
            fullMarksRW,
            result.full_marks_sl,
          ),
        };
      }),
    );
  };

  const onChangeGainMarksRW = (e, index) => {
    const gainMarksRW = e.target.value;
    const item = allResultList[index];

    if (Number(gainMarksRW) <= Number(item.full_marks_rw)) {
      setallResultList((results) =>
        results.map((result, resultIndex) =>
          resultIndex === index
            ? {
                ...result,
                gain_marks_rw: gainMarksRW,
                ...calculatePartialResult(
                  gainMarksRW,
                  result.gain_marks_sl,
                  result.full_marks_rw,
                  result.full_marks_sl,
                ),
              }
            : result,
        ),
      );
    }
  };

  const OnchangefullMarkLS = (e, index) => {
    const fullMarksLS = e.target.value;

    setallResultList((results) =>
      results.map((result, resultIndex) => {
        if (resultIndex !== index) {
          return result;
        }

        const gainMarksLS =
          Number(result.gain_marks_sl || 0) > Number(fullMarksLS || 0)
            ? 0
            : result.gain_marks_sl;

        return {
          ...result,
          full_marks_sl: fullMarksLS,
          gain_marks_sl: gainMarksLS,
          ...calculatePartialResult(
            result.gain_marks_rw,
            gainMarksLS,
            result.full_marks_rw,
            fullMarksLS,
          ),
        };
      }),
    );
  };

  const onChangeGainMarksLS = (e, index) => {
    const gainMarksLS = e.target.value;
    const item = allResultList[index];

    if (Number(gainMarksLS) <= Number(item.full_marks_sl)) {
      setallResultList((results) =>
        results.map((result, resultIndex) =>
          resultIndex === index
            ? {
                ...result,
                gain_marks_sl: gainMarksLS,
                ...calculatePartialResult(
                  result.gain_marks_rw,
                  gainMarksLS,
                  result.full_marks_rw,
                  result.full_marks_sl,
                ),
              }
            : result,
        ),
      );
    }
  };

  const onChangePracticalMarks = (e, index, gain, full) => {
    if (Number(e.target.value) + Number(gain) > Number(full)) {
      return alert.error(
        "Gain marks + presentation marks cannot be greater then total marks",
      );
    }
    const practicalMarks = e.target.value;

    setallResultList((results) =>
      results.map((result, resultIndex) =>
        resultIndex === index
          ? {
              ...result,
              practical_marks: practicalMarks,
              ...calculateResult(
                result.gain_marks,
                practicalMarks,
                result.full_marks,
              ),
            }
          : result,
      ),
    );
  };

  const updateResult = () => {
    setupdateloading(true);

    let result_id = [];
    let full_marks = [];
    let gain_marks = [];
    let full_marks_rw = [];
    let gain_marks_rw = [];
    let full_marks_sl = [];
    let gain_marks_sl = [];
    let percentage = [];
    let grade = [];
    let practical_marks = [];
    let status = [];
    let subject_id = [];

    allResultList.forEach((ele) => {
      result_id.push(ele.id);
      full_marks.push(ele.full_marks);
      gain_marks.push(ele.gain_marks ? ele.gain_marks : 0);
      full_marks_rw.push(ele.full_marks_rw ? ele.full_marks_rw : 0);
      gain_marks_rw.push(ele.gain_marks_rw ? ele.gain_marks_rw : 0);
      full_marks_sl.push(ele.full_marks_sl ? ele.full_marks_sl : 0);
      gain_marks_sl.push(ele.gain_marks_sl ? ele.gain_marks_sl : 0);
      percentage.push(ele.percentage);
      grade.push(ele.grade);
      practical_marks.push(ele.practical_marks);
      status.push(ele.status);
      subject_id.push(ele.subject_id);
    });

    console.log(status);

    let formdata = new FormData();

    // formdata.append('result_id[]', result_id)
    // formdata.append('full_marks[]', full_marks)
    // formdata.append('gain_marks[]', gain_marks)
    // formdata.append('percentage[]', percentage)
    // formdata.append('grade[]', grade)
    // formdata.append('practical_marks[]', practical_marks)

    for (let i = 0; i < result_id.length; i++) {
      formdata.append(`result_id[${i}]`, result_id[i]);
    }
    for (let i = 0; i < full_marks.length; i++) {
      formdata.append(`full_marks[${i}]`, full_marks[i]);
    }
    for (let i = 0; i < gain_marks.length; i++) {
      formdata.append(`gain_marks[${i}]`, gain_marks[i]);
    }
    for (let i = 0; i < full_marks_rw.length; i++) {
      formdata.append(`full_marks_rw[${i}]`, full_marks_rw[i]);
    }
    for (let i = 0; i < gain_marks_rw.length; i++) {
      formdata.append(`gain_marks_rw[${i}]`, gain_marks_rw[i]);
    }
    for (let i = 0; i < full_marks_sl.length; i++) {
      formdata.append(`full_marks_sl[${i}]`, full_marks_sl[i]);
    }
    for (let i = 0; i < gain_marks_sl.length; i++) {
      formdata.append(`gain_marks_sl[${i}]`, gain_marks_sl[i]);
    }
    for (let i = 0; i < percentage.length; i++) {
      formdata.append(`percentage[${i}]`, percentage[i]);
    }
    for (let i = 0; i < grade.length; i++) {
      formdata.append(`grade[${i}]`, grade[i]);
    }
    for (let i = 0; i < practical_marks.length; i++) {
      formdata.append(`practical_marks[${i}]`, practical_marks[i]);
    }
    for (let i = 0; i < status.length; i++) {
      formdata.append(`status[${i}]`, status[i]);
    }
    for (let i = 0; i < subject_id.length; i++) {
      formdata.append(`subject_id[${i}]`, subject_id[i]);
    }
    formdata.append("exam_id", selectedExamType);

    for (var pair of formdata.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    fetch(`${baseUrl}/single-result-update`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          alert.success("Result update successfully");
          setupdateloading(false);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg);
            setupdateloading(false);
          });
        }

        console.log(data);
      })
      .catch((err) => {
        setupdateloading(false);

        console.log(err);
      });
  };

  //printing function

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const onStatusChange = (e, index) => {
    let arr = [...allResultList];
    let newVal = e.target.value;

    arr[index].status = newVal;
    if (newVal != "Present") {
      arr[index].gain_marks = 0;
      arr[index].gain_marks_rw = 0;
      arr[index].gain_marks_sl = 0;
      arr[index].percentage = 0;
      arr[index].practical_marks = 0;
      arr[index].grade = getGradeForPercentage(0);
    }
    setallResultList(arr);
  };

  const printdoc = () => {
    function printElement(elem) {
      var $printSection1 = document.getElementById("printSection");
      if (!$printSection1) {
        var $printSection1 = document.createElement("div");
        $printSection1.id = "printSection";
        document.body.appendChild($printSection1);
      }

      $printSection1.innerHTML = elem;
      // $printSection1.appendChild(domClone);
      window.print();
    }

    printElement(document.getElementById("result-p").innerHTML);
  };

  const inputRefs = useRef([]);
  const inputRefs1 = useRef([]);
  const isPartialResult = (item) => String(item?.subject?.is_partial) === "1";
  const hasPartialResults = allResultList.some(isPartialResult);
  const hasStandardResults = allResultList.some(
    (item) => !isPartialResult(item),
  );
  const reportHeaderStyle = {
    fontSize: "16px",
    border: "1px solid black",
  };
  const reportCellStyle = {
    fontSize: "16px",
    color: "black",
    border: "1px solid black",
    padding: "1px",
  };

  const renderReportMarkHeaders = () => (
    <>
      {hasStandardResults || !hasPartialResults ? (
        <>
          <th style={reportHeaderStyle} className="text-center">
            <b>Total Marks</b>
          </th>
          <th style={reportHeaderStyle} className="text-center">
            <b>Gain Marks</b>
          </th>
        </>
      ) : null}
      {hasPartialResults ? (
        <>
          <th style={reportHeaderStyle} className="text-center">
            <b>Total Marks RW</b>
          </th>
          <th style={reportHeaderStyle} className="text-center">
            <b>Gain Marks RW</b>
          </th>
          <th style={reportHeaderStyle} className="text-center">
            <b>Total Marks LS</b>
          </th>
          <th style={reportHeaderStyle} className="text-center">
            <b>Gain Marks LS</b>
          </th>
        </>
      ) : null}
    </>
  );

  const renderReportMarkCells = (item) => (
    <>
      {hasStandardResults || !hasPartialResults ? (
        isPartialResult(item) ? (
          <>
            <td style={reportCellStyle} className="text-center">
              -
            </td>
            <td style={reportCellStyle} className="text-center">
              -
            </td>
          </>
        ) : (
          <>
            <td style={reportCellStyle} className="text-center">
              {!printEmpty ? item.full_marks : ""}
            </td>
            <td style={reportCellStyle} className="text-center">
              {!printEmpty ? item.gain_marks : ""}
            </td>
          </>
        )
      ) : null}
      {hasPartialResults ? (
        isPartialResult(item) ? (
          <>
            <td style={reportCellStyle} className="text-center">
              {!printEmpty ? item.full_marks_rw : ""}
            </td>
            <td style={reportCellStyle} className="text-center">
              {!printEmpty ? item.gain_marks_rw : ""}
            </td>
            <td style={reportCellStyle} className="text-center">
              {!printEmpty ? item.full_marks_sl : ""}
            </td>
            <td style={reportCellStyle} className="text-center">
              {!printEmpty ? item.gain_marks_sl : ""}
            </td>
          </>
        ) : (
          <>
            <td style={reportCellStyle} className="text-center">
              -
            </td>
            <td style={reportCellStyle} className="text-center">
              -
            </td>
            <td style={reportCellStyle} className="text-center">
              -
            </td>
            <td style={reportCellStyle} className="text-center">
              -
            </td>
          </>
        )
      ) : null}
    </>
  );

  const handleKeyDown = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs.current.length;
      const nextInput = inputRefs.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const handleKeyDown1 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex1 = (index + 1) % inputRefs1.current.length;
      const nextInput1 = inputRefs1.current[nextIndex1];

      if (nextInput1) {
        nextInput1.focus();
        nextInput1.select();
      }
    }
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "10px" }}
      >
        <div className="row">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <select
              onChange={(e) => onChangeSession(e.target.value)}
              class="form-select"
              style={{ height: 40 }}
              value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session) => (
                <option key={session.id} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus</b>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="campus_id"
              value={selectedcampus}
              onChange={(e) => onCampusChange(e.target.value)}
              aria-label="Default select example"
            >
              <option value=""> Select Campus</option>
              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Exam</b>
            </label>
            <select
              onChange={(e) => {
                setselectedExamType(e.target.value);
                let finded = allexamslist.find(
                  (item) => item.id == e.target.value,
                );
                setallclasses(finded.student_classes);
              }}
              class="form-select"
              style={{ height: 40 }}
              // value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Exam</option>
              {allexamslist.map((exam) => (
                <option key={exam.id} value={exam.id}>
                  {exam?.exam_name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>
              <b>Enter Admission No.</b>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Admission No."
              onChange={(e) => setAdmissionNo(e.target.value)}
              value={admissionNo}
              style={{ height: 40 }}
              aria-label="Default select example"
            />
          </div>
        </div>
        <div className="row mt-3">
          {/* <div style={{ height: 40 }} className="col-md-3 mt-3">
            <input type="checkbox" style={{ display: "none" }} />
            <label className="checkbox checkbox-single">
              <input
                type="checkbox"
                onChange={(e) => setisPracticalMode(e.target.checked)}
              />
              <span />
              &nbsp;&nbsp;&nbsp;Include Presentation
            </label>
          </div> */}
          <div className="col-md-12 mt-3" style={{ height: 40 }}>
            <input type="checkbox" style={{ display: "none" }} />
            <label className="checkbox checkbox-single">
              <input
                checked={printEmpty}
                type="checkbox"
                onChange={(e) => setPrintEmpty(e.target.checked)}
              />
              <span />
              &nbsp;&nbsp;&nbsp;Print Empty
            </label>
          </div>

          <div
            className="col d-flex justify-content-between"
            style={{ height: 40 }}
          >
            <div>
              <button
                disabled={loading ? true : false}
                className="btn btn-primary mx-2"
                onClick={getStudentResult}
              >
                {loading ? "Loading..." : "Get Result"}
              </button>

              {allResultList.length > 0 ? (
                <ReactToPrint
                  documentTitle="Enter Result"
                  pageStyle={pageStyle}
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary w-100px mx-2"
                    >
                      {printloading ? "Printing..." : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />
              ) : null}

              <DownloadTableExcel
                filename="Enter Result Export"
                sheet="Enter Result Export"
                currentTableRef={tableRef.current}
              >
                {allResultList.length > 0 && (
                  <button className="btn btn-primary mx-2">Export</button>
                )}
              </DownloadTableExcel>
            </div>
            <div>
              <button
                disabled={updateloading ? true : false}
                className="btn btn-primary mx-2"
                onClick={updateResult}
              >
                {updateloading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : (
          <Table responsive style={{ overflow: "scroll" }}>
            <thead>
              <tr>
                <td className="text-center">Sr.No</td>
                <td className="text-center">Admission No</td>
                <td className="text-center">Student Name</td>
                <td className="text-center">Subject</td>
                {hasStandardResults || !hasPartialResults ? (
                  <>
                    <td className="text-center">Total Marks</td>
                    <td className="text-center">Gain Marks</td>
                  </>
                ) : null}
                {hasPartialResults ? (
                  <>
                    <td className="text-center">Total Marks RW</td>
                    <td className="text-center">Gain Marks RW</td>
                    <td className="text-center">Total Marks LS</td>
                    <td className="text-center">Gain Marks LS</td>
                  </>
                ) : null}
                <td className="text-center">Status</td>
                {isPracticalMode ? (
                  <td className="text-center">Presentation Marks</td>
                ) : null}
                <td className="text-center">Persentage</td>
                <td className="text-center">Grade</td>
              </tr>
            </thead>
            <tbody>
              {allResultList.length > 0
                ? allResultList.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {item.student?.admission_id}
                      </td>
                      <td className="text-center">{item.student?.name}</td>
                      <td className="text-center">{item?.subject?.name}</td>
                      {hasStandardResults ? (
                        isPartialResult(item) ? (
                          <>
                            <td className="text-center">-</td>
                            <td className="text-center">-</td>
                          </>
                        ) : (
                          <>
                            <td className="text-center">
                              <input
                                onChange={(e) => OnchangefullMark(e, index)}
                                value={item.full_marks}
                                placeholder={"Total Marks"}
                                ref={(ref) => (inputRefs.current[index] = ref)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                              />
                            </td>
                            <td className="text-center">
                              <input
                                disabled={item.status != "Present"}
                                onChange={(e) => onChangeGainMarks(e, index)}
                                value={item.gain_marks}
                                placeholder={"Gain Marks"}
                                ref={(ref) => (inputRefs.current[index] = ref)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                              />
                            </td>
                          </>
                        )
                      ) : null}
                      {hasPartialResults ? (
                        isPartialResult(item) ? (
                          <>
                            <td className="text-center">
                              <input
                                onChange={(e) => OnchangefullMarkRW(e, index)}
                                value={item.full_marks_rw}
                                placeholder={"Total Marks RW"}
                                ref={(ref) => (inputRefs.current[index] = ref)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                              />
                            </td>
                            <td className="text-center">
                              <input
                                disabled={item.status != "Present"}
                                onChange={(e) => onChangeGainMarksRW(e, index)}
                                value={item.gain_marks_rw}
                                placeholder={"Gain Marks RW"}
                                ref={(ref) => (inputRefs.current[index] = ref)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                              />
                            </td>
                            <td className="text-center">
                              <input
                                onChange={(e) => OnchangefullMarkLS(e, index)}
                                value={item.full_marks_sl}
                                placeholder={"Total Marks LS"}
                                ref={(ref) => (inputRefs1.current[index] = ref)}
                                onKeyDown={(e) => handleKeyDown1(e, index)}
                              />
                            </td>
                            <td className="text-center">
                              <input
                                disabled={item.status != "Present"}
                                onChange={(e) => onChangeGainMarksLS(e, index)}
                                value={item.gain_marks_sl}
                                placeholder={"Gain Marks LS"}
                                ref={(ref) => (inputRefs1.current[index] = ref)}
                                onKeyDown={(e) => handleKeyDown1(e, index)}
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="text-center">-</td>
                            <td className="text-center">-</td>
                            <td className="text-center">-</td>
                            <td className="text-center">-</td>
                          </>
                        )
                      ) : null}
                      <td className="text-center">
                        <select
                          style={{ height: 40, width: "120px" }}
                          className="form-select"
                          name="status"
                          value={item.status}
                          onChange={(e) => onStatusChange(e, index)}
                          aria-label="Default select example"
                        >
                          <option selected value="Present">
                            Present
                          </option>
                          <option value="Absent">Absent</option>
                          <option value="Leave">Leave</option>
                        </select>
                      </td>
                      {isPracticalMode ? (
                        <td className="text-center">
                          <input
                            onChange={(e) =>
                              onChangePracticalMarks(
                                e,
                                index,
                                item.gain_marks,
                                item.full_marks,
                              )
                            }
                            value={item.practical_marks}
                            placeholder={"Presentation Marks"}
                            ref={(ref) => (inputRefs1.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown1(e, index)}
                          />
                        </td>
                      ) : null}
                      <td className="text-center">{item.percentage}%</td>
                      <td className="text-center">{item.grade}</td>
                    </tr>
                  ))
                : null}
            </tbody>
          </Table>
        )}
      </Paper>

      {/* Print Enter Result Export */}
      <div style={{ visibility: "hidden" }}>
        <div ref={componentRef} id="printSection">
          <div className="p-3" style={{ display: "flex" }}>
            <img style={{ height: 100, width: 110 }} src={icon} />

            <div className="col-md-8" style={{ paddingTop: "25px" }}>
              <h1>{unitName}</h1>
              <div className="d-flex justify-content-between">
                <div>
                  <h3>
                    <b>Campus: {examDetails.campus?.name}</b>
                  </h3>
                  {/* <h3>
                    <b>Subject: {subjectDetails.name}</b>
                  </h3> */}
                </div>
                <div>
                  <h3>
                    <b>Class: {classDetails?.name}</b>
                  </h3>
                  <h3>
                    <b>Section: {sectionDetails?.name}</b>
                  </h3>
                </div>
                {/* <div>
                  <p
                    style={{
                      fontSize: "16px",
                      color: "black",
                      margin: "0",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                    }}
                  >
                    {printEmpty ? "" : allResultList[0]?.full_marks}
                  </p>
                  <div>
                    <p style={{ fontSize: "16px", color: "black" }}>
                      Total Marks
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div style={{ width: "100%", textAlign: "center" }}>
            <h1>{examDetails.exam_type?.name}</h1>
          </div>

          <Table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  <b>Sr.No</b>
                </th>

                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  <b>Student Name</b>
                </th>
                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  <b>Subject</b>
                </th>
                {subjectDetails?.is_partial == "1" ? (
                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    <b>Gain Marks RW + SL</b>
                  </th>
                ) : (
                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    <b>Gain Marks</b>
                  </th>
                )}
                {isPracticalMode ? (
                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    <b>Presentation Marks</b>
                  </th>
                ) : null}

                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  {" "}
                  <b>Total Marks</b>
                </th>
              </tr>
            </thead>
            <tbody>
              {allResultList.map((item, index) => (
                <tr key={item.id}>
                  <td
                    className="text-center"
                    style={{
                      fontSize: "16px",
                      color: "black",
                      border: "1px solid black",
                      padding: "1px",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td
                    className="text-lef"
                    style={{
                      fontSize: "16px",
                      color: "black",
                      border: "1px solid black",
                      padding: "1px",
                    }}
                  >
                    {item.student?.name}
                  </td>
                  <td
                    className="text-center"
                    style={{
                      fontSize: "16px",
                      color: "black",
                      border: "1px solid black",
                      padding: "1px",
                    }}
                  >
                    {item.subject?.name}
                  </td>

                  {item.subject?.is_partial == "1" ? (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty
                        ? item.gain_marks_rw + " + " + item.gain_marks_sl
                        : ""}
                    </td>
                  ) : (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty ? item.gain_marks : ""}
                    </td>
                  )}
                  {isPracticalMode ? (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty ? item.practical_marks : ""}
                    </td>
                  ) : null}
                  {item.subject?.is_partial == "1" ? (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty
                        ? Number(item.full_marks_rw) +
                          " + " +
                          Number(item.full_marks_sl)
                        : ""}
                    </td>
                  ) : (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty ? Number(item.full_marks) : ""}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      {/* Export Enter Result Export */}
      <div style={{ visibility: "hidden" }}>
        <div ref={tableRef} id="printSection">
          <div className="p-3" style={{ display: "flex" }}>
            <img style={{ height: 100, width: 110 }} src={icon} />

            <div className="col-md-8" style={{ paddingTop: "25px" }}>
              <h1>{unitName}</h1>
              <div className="d-flex justify-content-between">
                <div>
                  <h3>
                    <b>Campus: {examDetails.campus?.name}</b>
                  </h3>
                  {/* <h3>
                    <b>Subject: {subjectDetails.name}</b>
                  </h3> */}
                </div>
                <div>
                  <h3>
                    <b>Class: {classDetails?.name}</b>
                  </h3>
                  <h3>
                    <b>Section: {sectionDetails?.name}</b>
                  </h3>
                </div>
                {/* <div>
                  <p
                    style={{
                      fontSize: "16px",
                      color: "black",
                      margin: "0",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                    }}
                  >
                    {printEmpty ? "" : allResultList[0]?.full_marks}
                  </p>
                  <div>
                    <p style={{ fontSize: "16px", color: "black" }}>
                      Total Marks
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div style={{ width: "100%", textAlign: "center" }}>
            <h1>{examDetails.exam_type?.name}</h1>
          </div>
          <Table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  <b>Sr.No</b>
                </th>

                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  <b>Student Name</b>
                </th>
                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  <b>Subject</b>
                </th>
                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  <b>Gain Marks</b>
                </th>
                {isPracticalMode ? (
                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    <b>Presentation Marks</b>
                  </th>
                ) : null}
                <th
                  style={{ fontSize: "16px", border: "1px solid black" }}
                  className="text-center"
                >
                  {" "}
                  <b>Total Marks</b>
                </th>
              </tr>
            </thead>
            <tbody>
              {allResultList.map((item, index) => (
                <tr key={item.id}>
                  <td
                    className="text-center"
                    style={{
                      fontSize: "16px",
                      color: "black",
                      border: "1px solid black",
                      padding: "1px",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td
                    className="text-lef"
                    style={{
                      fontSize: "16px",
                      color: "black",
                      border: "1px solid black",
                      padding: "1px",
                    }}
                  >
                    {item.student?.name}
                  </td>
                  <td
                    className="text-center"
                    style={{
                      fontSize: "16px",
                      color: "black",
                      border: "1px solid black",
                      padding: "1px",
                    }}
                  >
                    {item.subject?.name}
                  </td>

                  {item.subject?.is_partial == "1" ? (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty
                        ? item.gain_marks_rw + " + " + item.gain_marks_sl
                        : ""}
                    </td>
                  ) : (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty ? item.gain_marks : ""}
                    </td>
                  )}
                  {isPracticalMode ? (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty ? item.practical_marks : ""}
                    </td>
                  ) : null}
                  {item.subject?.is_partial == "1" ? (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty
                        ? Number(item.full_marks_rw) +
                          " + " +
                          Number(item.full_marks_sl)
                        : ""}
                    </td>
                  ) : (
                    <td
                      className="text-cente"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {!printEmpty ? Number(item.full_marks) : ""}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default SingleResult;
